import { fetcher } from '@commenda/utils';

/**
 * Resets a corporation's compliance-monitor onboarding so it can be redone. Backend-restricted to
 * Commenda admins
 */
export async function redoComplianceMonitorOnboarding(
  corporationId: number
): Promise<Response | null> {
  return fetcher(`compliance-monitors/${corporationId}/onboarding/redo`, {
    method: 'POST',
  });
}
